// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { layers } from '@atlaskit/theme/constants';
import { N900, N20, P300, N300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

const AkGrid = (num: number = 1) => ({
	px: `${num * 8}px`,
	unitless: num * 8,
	multiple: (multiplier: number) => AkGrid(multiplier * num),
	half: () => AkGrid(0.5 * num),
	twice: () => AkGrid(2 * num),
});

export const zIndex = {
	searchDialog: layers.dialog(),
};

export const grid = AkGrid(1);

export const atlassianNavigationHeight = '56px';

export const collapsedSearchInputWidth = '200px';
export const filterLabelWidth = '150px';

export const dialogWidth = '780px';
export const dialogPageTakeoverWidth: number = 780;
export const dialogPageCentreWidth = '1130px';

export const inputFieldHeight = grid.multiple(4);
export const enlargedInputFieldHeight = grid.multiple(6);

export const primaryTextColour = token('color.text', N900);
export const itemLinkSecondaryColor = token('color.text.subtlest', N300);
export const itemHighlightColor = token('color.background.neutral.subtle.hovered', N20);
export const visitedLinkColor = token('color.link.visited', P300);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const nowrapEllipsis = css({
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
});
